import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { useLanguage, SUPPORTED_LANGS, DEFAULT_LANG } from "../i18n";

const Wrapper = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;
  font-size: 0.85rem;
`;

const LangLink = styled(Link)`
  color: ${(props) => (props.$active ? "#e06630" : "#666")};
  font-weight: ${(props) => (props.$active ? "700" : "400")};
  text-decoration: none;
  padding: 2px 4px;

  &:hover {
    color: #e06630;
  }
`;

const Separator = styled.span`
  color: #ccc;
  user-select: none;
`;

function getBasePath(pathname) {
  return pathname.replace(/^\/(en|de)/, "") || "/";
}

const LanguageSwitcher = () => {
  const { lang } = useLanguage();
  const location = useLocation();
  const basePath = getBasePath(location.pathname);

  const paths = SUPPORTED_LANGS.map((l) => ({
    code: l,
    path: l === DEFAULT_LANG ? basePath : `/${l}${basePath}`,
  }));

  return (
    <Wrapper>
      {paths.map((l, i) => (
        <span key={l.code}>
          {i > 0 && <Separator>|</Separator>}
          <LangLink to={l.path} $active={l.code === lang}>
            {l.code.toUpperCase()}
          </LangLink>
        </span>
      ))}
    </Wrapper>
  );
};

export default LanguageSwitcher;
